/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useRef, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { Form, Select, Radio } from 'formik-antd';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Box, FormInput, CustomInput, Button, Text } from 'atoms';
import { Debug } from './Debug';
import { ACL, BoxMod, EditModeBtn, ImageView } from 'components/common';
// import { useQuery } from 'hooks';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { DATE_FORMAT, gstRegType, pdfimgfiletypetoShow, pdfimgformates } from 'utils';
import { CancelButton, DatePickers } from 'utils/commonStyled';
import { updateVendorSection } from 'store/vendorSlice';

export default function VendorAllSectionForm({
	isEditMode = false,
	formData = {},
	otherFormsData,
	activeTab,
}) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [filesList, setFilesList] = useState([]);
	const [editMode, setEditMode] = useState(false);
	console.log(activeTab);
	console.log(formData);
	console.log(otherFormsData);

	const FormSchema = useMemo(
		() =>
			Yup.object({
				vendor_type: Yup.string().label('Vendor Type'),
				acc_number: Yup.string()
					.required()
					.min(6)
					.max(24)
					.label('Account Number')
					.matches(/^[0-9]*$/, 'Please enter valid Account Number'),
				ifsc_code: Yup.string()
					.required()
					.min(11)
					.max(11)
					.label('IFSC Code')
					.matches(/^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/, 'Please enter valid IFSC ode'),
				bank_name: Yup.string()
					.required()
					.min(4)
					.max(30)
					.label('Bank Name')
					.matches(/^[a-zA-Z ]*$/, 'Please enter valid Bank Name'),
				bank_city: Yup.string()
					.required()
					.label('Bank City')
					.matches(/^[a-zA-Z ]*$/, 'Please enter valid City'),
				bank_branch: Yup.string()
					.required()
					.min(5)
					.max(32)
					.label('Bank Branch')
					.matches(/^[a-zA-Z0-9 -.,&/()]*$/, 'Please enter valid Branch'),
				pan_number: Yup.string()
					.required()
					.min(10)
					.max(25)
					.label('Pan Number')
					.matches(/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/, 'Please enter valid Pan Number'),
				gst_reg_type: Yup.string().required().label('GSt reg type'),
				bank_doc: Yup.array().required(),
				aadhar_number: Yup.string()
					.min(12)
					.max(12)
					.label('Aadhar number')
					.matches(/^[0-9]*$/, 'Please enter valid Aadhar number'),
				gst_number: Yup.string()
					.min(15)
					.max(15)
					.label('GST number')
					.when('gst_reg_type', (gst_reg_type, schema) => {
						if (gst_reg_type === 'registered') return schema.required();
						return schema;
					}),
				related_party: Yup.boolean().required().label('Related Party'),
				black_listed: Yup.boolean().required().label('Black Listed'),
				holding_payment: Yup.boolean().required().label('Holding Payment'),
				logistic_vendor: Yup.boolean().required().label('Logistic vendor'),
				discount_early_payment: Yup.boolean().required().label('Discount Early Payment'),
				tds_applicable: Yup.boolean().required().label('TDS Applicable'),
				document_currency: Yup.string()
					.min(3)
					.max(500)
					.label('Document Currency')
					.matches(/^[a-zA-Z]*$/, 'Document Currency can only contain alphabets'),
				credit_period: Yup.number().min(1).max(999).label('credit period'),
				payment_tnc: Yup.string()
					.label('payment tnc')
					.min(2)
					.max(500)
					.matches(
						/^[a-zA-Z0-9 ,.-]*$/,
						'Payment TNC should only be alpha-Numeric, . (dot), - (hyphen) and , (commma) allowed'
					),
				tax_cert_start_date: Yup.date()
					.label('Start Date')
					.when('cert_no', (cert_no, schema) => {
						if (cert_no) return schema.required();
						return schema;
					}),
				tax_cert_valid_till: Yup.date()
					.when('cert_no', (cert_no, schema) => {
						if (cert_no) return schema.required();
						return schema;
					})
					.label('Valid Till')
					.when(
						'tax_cert_start_date',
						(tax_cert_start_date, yup) =>
							tax_cert_start_date &&
							yup.min(tax_cert_start_date, 'End Date cannot be before Start Date')
					),
				cert_no: Yup.string()
					.min(4)
					.max(32)
					.label('Certificate No.')
					.matches(
						/^[a-zA-Z0-9]*$/,
						'Certificate should be Alpha-numeric, . (dot) and - (hyphen) not allowed'
					),
				is_vendor_msme: Yup.boolean(),
				msme_reg_no: Yup.string()
					.min(16)
					.max(16)
					.label('MSME Registration Number')
					.matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric value allowed')
					.when('is_vendor_msme', (is_vendor_msme, schema) => {
						if (is_vendor_msme) return schema.required();
						return schema;
					}),
			}),
		[]
	);

	const getMonentDate = (date) => {
		console.log(date);
		return date === '' ? undefined : moment(date);
	};

	const initialValues = useMemo(
		() => ({
			vendor_type: formData?.vendor_type || undefined,
			acc_number: formData?.banking_info?.acc_number || undefined,
			ifsc_code: formData?.banking_info?.ifsc_code || undefined,
			bank_name: formData?.banking_info?.bank_name || undefined,
			bank_city: formData?.banking_info?.bank_city || undefined,
			bank_doc: formData?.banking_info?.bank_doc || undefined,
			bank_branch: formData?.banking_info?.bank_branch || undefined,
			pan_number: formData?.document_info?.pan_number || undefined,
			gst_reg_type: formData?.document_info?.gst_reg_type || undefined,
			aadhar_number: formData?.document_info?.aadhar_number || undefined,
			gst_number: formData?.document_info?.gst_number || undefined,
			related_party: formData?.other_info?.related_party || false,
			black_listed: formData?.other_info?.black_listed || false,
			holding_payment: formData?.other_info?.holding_payment || false,
			logistic_vendor: formData?.other_info?.logistic_vendor || false,
			discount_early_payment: formData?.other_info?.discount_early_payment || false,
			tds_applicable: formData?.other_info?.tds_applicable || false,
			document_currency: formData?.other_info?.document_currency || undefined,
			credit_period: formData?.other_info?.credit_period || undefined,
			payment_tnc: formData?.payment_tnc || undefined,
			cert_no: formData?.tax_info?.cert_no || undefined,
			tax_cert_start_date:
				getMonentDate(formData?.tax_info?.tax_cert_start_date) || undefined,
			tax_cert_valid_till:
				getMonentDate(formData?.tax_info?.tax_cert_valid_till) || undefined,
			is_vendor_msme: formData?.other_info?.is_vendor_msme || false,
			msme_reg_no: formData?.other_info?.msme_reg_no || undefined,
		}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formData]
	);

	// const getValidIMages = (bank_doc) => {
	// 	if (bank_doc) {
	// 		return bank_doc;
	// 	}
	// 	if (!isEmpty(filesList)) {
	// 		return filesList;
	// 	}
	// 	return undefined;
	// };
	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		let payload = {};
		if (formData?.vendor_type === 'regular') {
			payload = {
				update_type: 'vendor',
				id: formData?.id,
				vendor_type: 'regular',
				vendor_info: formData?.vendor_info,
				vrf_signed_copy: otherFormsData?.vrf_signed_copy,
				banking_info: {
					acc_number: values?.acc_number,
					bank_branch: values?.bank_branch,
					bank_city: values?.bank_city,
					bank_name: values?.bank_name,
					ifsc_code: values?.ifsc_code.toUpperCase(),
					bank_doc: !isEmpty(filesList) ? filesList : formData?.banking_info?.bank_doc,
				},
				document_info: {
					pan_number: values?.pan_number.toUpperCase(),
					gst_reg_type: values?.gst_reg_type,
					aadhar_number: values?.aadhar_number,
					gst_number: values?.gst_number,
					pan_doc: !isEmpty(panFilesList)
						? panFilesList
						: formData?.document_info?.pan_doc,
					aadhar_doc: !isEmpty(aadharFilesList)
						? aadharFilesList
						: formData?.document_info?.aadhar_doc,
					gst_doc: !isEmpty(gstFilesList)
						? gstFilesList
						: formData?.document_info?.gst_doc,
				},
				tax_info: {
					cert_no: values?.cert_no,
					tax_cert_start_date: values?.cert_no
						? moment(values?.tax_cert_start_date).format(DATE_FORMAT)
						: undefined,
					tax_cert_valid_till: values?.cert_no
						? moment(values?.tax_cert_valid_till).format(DATE_FORMAT)
						: undefined,
				},
				other_info: {
					related_party: values?.related_party,
					black_listed: values?.black_listed,
					holding_payment: values?.holding_payment,
					logistic_vendor: values?.logistic_vendor,
					discount_early_payment: values?.discount_early_payment,
					tds_applicable: values?.tds_applicable,
					document_currency: values?.document_currency,
					credit_period: Number(values?.credit_period),
					payment_tnc: values?.payment_tnc,
					is_vendor_msme: values?.is_vendor_msme,
					msme_reg_no: values?.msme_reg_no,
				},
			};
		}
		if (formData?.vendor_type !== 'regular') {
			payload = {
				update_type: 'vendor',
				id: formData?.id,
				vendor_type: 'temporary',
				vendor_info: formData?.vendor_info,
				banking_info: {
					acc_number: values?.acc_number,
					bank_branch: values?.bank_branch,
					bank_city: values?.bank_city,
					bank_name: values?.bank_name,
					ifsc_code: values?.ifsc_code.toUpperCase(),
					bank_doc: !isEmpty(filesList) ? filesList : formData?.banking_info?.bank_doc,
				},
				document_info: {
					pan_number: values?.pan_number.toUpperCase(),
					gst_reg_type: values?.gst_reg_type,
					aadhar_number: values?.aadhar_number,
					gst_number: values?.gst_number,
					pan_doc: !isEmpty(panFilesList) ? panFilesList : formData?.pan_doc,
					aadhar_doc: !isEmpty(aadharFilesList) ? aadharFilesList : formData?.aadhar_doc,
					gst_doc: !isEmpty(gstFilesList) ? gstFilesList : formData?.gst_doc,
				},
			};
		}
		console.log(payload);
		dispatch(
			updateVendorSection({
				req_data: payload,
				setErrors,
			})
		)
			.then((res) => {
				console.log(res);
				// if (res?.data?.vendor_type === 'regular') {
				// 	window.location = `${window.origin}/vendor/edit/${res.data.id}?tab=3&isEdit=false`;
				// 	setSubmitting(false);
				// } else {
				navigate('/vendor-list');
				setSubmitting(false);
				// }
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handleFileUpload(files, key, setFieldValue) {
		console.log('handleFileUpload', files, key);
		formData.bank_doc = files;
		setFieldValue('bank_doc', files);
		setFilesList(files);
	}

	function handleGstType(e, setFieldValue) {
		if (e === 'unregistered') {
			setTimeout(() => {
				setFieldValue('gst_number', undefined);
			}, 200);
		}
	}

	function handleMSME(e, setFieldValue) {
		if (e.target.value === false) {
			setTimeout(() => {
				setFieldValue('msme_reg_no', undefined);
			}, 200);
		}
	}

	const HeaderText = styled(Text)`
		color: #1890ff;
		font-size: 21px;
		background: #cccc;
		margin-top: 15px;
		padding: 10px;
	`;

	const ref = useRef(null);

	const [panFilesList, setPanFilesList] = useState([]);
	const [aadharFilesList, setAadharFilesList] = useState([]);
	const [gstFilesList, setGstFilesList] = useState([]);

	function handlePanFileUpload(files) {
		console.log('handlePanFileUpload', files);
		setPanFilesList(files);
	}
	function handleAadharFileUpload(files) {
		console.log('handleAadharFileUpload', files);
		setAadharFilesList(files);
	}
	function handleGstFileUpload(files) {
		console.log('handleGstFileUpload', files);
		setGstFilesList(files);
	}
	function handleEdit() {
		console.log('before edit mode ', editMode);
		setEditMode(!editMode);
		console.log('after mode ', editMode);
	}

	return (
		<Formik
			innerRef={ref}
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{({ values, setFieldValue, errors }) => {
				console.log({ errors });
				console.log(formData?.vendor_type);
				console.log({ setFieldValue });

				return (
					<Box>
						<ACL action="update" module="vendor">
							{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
						</ACL>
						<Form className={editMode === false ? 'disabled-div' : ''}>
							<HeaderText> Bank Details </HeaderText>
							<Box padding="1.5rem 2rem" background="#fff">
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="acc_number" label="Account Number *">
											<CustomInput name="acc_number" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="ifsc_code" label="IFSC Code *">
											<CustomInput name="ifsc_code" maxLength={11} />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="bank_name" label="Bank Name *">
											<CustomInput name="bank_name" />
										</FormInput>
									</Col>
									<Col lg={12}>
										<FormInput name="bank_city" label="Bank City *">
											<CustomInput name="bank_city" />
										</FormInput>
									</Col>
								</Row>
								<Row gutter={16} justify="space-between">
									<Col lg={12}>
										<FormInput name="bank_branch" label="Bank Branch *">
											<CustomInput name="bank_branch" />
										</FormInput>
									</Col>
								</Row>
							</Box>
							<Box border="1px solid #ccc" padding="34px">
								<FilesUploadS3
									entity="vendor"
									key="bank_doc"
									setFunc={setFieldValue}
									successCallBack={handleFileUpload}
									name="Bank document"
									size={5120000}
									fileformates={pdfimgformates}
									filetypetoShow={pdfimgfiletypetoShow}
								/>
								<Box>
									{errors?.bank_doc && (
										<Box backgroundColor="#fff" color="red">
											Bank Document is required
										</Box>
									)}
								</Box>
								<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
									{}
								</Box>
								{/* {filesList && (
									<ImageView
										entity="vendor"
										files={formData?.bank_doc}
										name="Bank Document"
									/>
								)} */}
								{isEditMode && (
									<ImageView
										entity="vendor"
										files={formData?.banking_info?.bank_doc}
										name="Bank Document"
									/>
								)}
							</Box>
							<Box>
								<HeaderText> Document Details </HeaderText>
								<Box padding="1.5rem 2rem" background="#fff">
									<Row gutter={16} justify="space-between">
										<Col lg={12}>
											<FormInput name="pan_number" label="PAN Number *">
												<CustomInput name="pan_number" />
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="gst_reg_type" label="GST reg type *">
												<Select
													name="gst_reg_type"
													filterOption={(input, option) =>
														option.label
															.toLowerCase()
															.indexOf(input.toLowerCase()) >= 0
													}
													onChange={(e) =>
														handleGstType(e, setFieldValue)
													}
													placeholder="Select"
													options={gstRegType}
												/>
											</FormInput>
										</Col>
									</Row>
									<Row gutter={16} justify="space-between">
										<Col lg={12}>
											<FormInput name="aadhar_number" label="Aadhar Number">
												<CustomInput name="aadhar_number" />
											</FormInput>
										</Col>
										<Col lg={12}>
											<FormInput name="gst_number" label="GST Number">
												<CustomInput
													disabled={
														values?.gst_reg_type === 'unregistered' ||
														values?.gst_reg_type === undefined
													}
													name="gst_number"
												/>
											</FormInput>
										</Col>
									</Row>
								</Box>
								<BoxMod></BoxMod>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="vendor"
										successCallBack={handlePanFileUpload}
										name="PAN document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {panFilesList && (
										<ImageView
											entity="vendor"
											files={formData?.pan_doc}
											name="PAN Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="vendor"
											files={formData?.document_info?.pan_doc}
											name="PAN Document"
										/>
									)}
								</Box>
								<BoxMod></BoxMod>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="vendor"
										successCallBack={handleAadharFileUpload}
										name="Aadhar document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {aadharFilesList && (
										<ImageView
											entity="vendor"
											files={formData?.aadhar_doc}
											name="AAdhar Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="vendor"
											files={formData?.document_info?.aadhar_doc}
											name="PAN Document"
										/>
									)}
								</Box>
								<BoxMod></BoxMod>
								<Box border="1px solid #ccc" padding="34px">
									<FilesUploadS3
										entity="vendor"
										successCallBack={handleGstFileUpload}
										name="GST document"
										size={5120000}
										fileformates={pdfimgformates}
										filetypetoShow={pdfimgfiletypetoShow}
									/>
									<Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
										{}
									</Box>
									{/* {gstFilesList && (
										<ImageView
											entity="vendor"
											files={formData?.gst_doc}
											name="GST Document"
										/>
									)} */}
									{isEditMode && (
										<ImageView
											entity="vendor"
											files={formData?.document_info?.gst_doc}
											name="PAN Document"
										/>
									)}
								</Box>
							</Box>
							{formData?.vendor_type === 'regular' && (
								<Box>
									<HeaderText> Tax Details </HeaderText>
									<Box padding="1.5rem 2rem" background="#fff">
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput name="cert_no" label="Certificate No.">
													<CustomInput name="cert_no" />
												</FormInput>
											</Col>
											{/* <Col lg={12}>
									<FormInput name="tds_section" label="TDS Section">
										<CustomInput name="tds_section" />
									</FormInput>
								</Col> */}
										</Row>

										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="tax_cert_start_date"
													label="Start date"
												>
													<DatePickers
														name="tax_cert_start_date"
														format="DD-MM-YYYY"
													/>
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="tax_cert_valid_till"
													label="Valid Till"
												>
													<DatePickers
														name="tax_cert_valid_till"
														format="DD-MM-YYYY"
													/>
												</FormInput>
											</Col>
										</Row>

										<Row gutter={16} justify="space-between">
											{/* <Col lg={12}>
									<FormInput name="tds_rate" label="TDS Rate">
										<CustomInput name="tds_rate" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="amount_limit" label="Amount Limit">
										<CustomInput name="amount_limit" />
									</FormInput>
								</Col> */}
										</Row>
									</Box>
									<HeaderText> Other Details </HeaderText>
									<Box padding="1.5rem 2rem" background="#fff">
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="related_party"
													label="Related Party *"
												>
													<Radio.Group
														name="related_party"
														defaultValue={values?.related_party}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="black_listed"
													label="Black Listed *"
												>
													<Radio.Group
														name="black_listed"
														defaultValue={values?.black_listed}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
										</Row>
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="holding_payment"
													label="Holding Payment *"
												>
													<Radio.Group
														name="holding_payment"
														defaultValue={values?.holding_payment}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="logistic_vendor"
													label="Logistic Vendor *"
												>
													<Radio.Group
														name="logistic_vendor"
														defaultValue={values?.logistic_vendor}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
										</Row>
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="discount_early_payment"
													label="Discount Early Payment *"
												>
													<Radio.Group
														name="discount_early_payment"
														defaultValue={
															values?.discount_early_payment
														}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="tds_applicable"
													label="TDS Applicable *"
												>
													<Radio.Group
														name="tds_applicable"
														defaultValue={values?.tds_applicable}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
										</Row>
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="is_vendor_msme"
													label="Vendor Registered MSME"
												>
													<Radio.Group
														name="is_vendor_msme"
														onChange={(e) =>
															handleMSME(e, setFieldValue)
														}
														defaultValue={values?.is_vendor_msme}
													>
														<Radio value>Yes</Radio>
														<Radio value={false}>No</Radio>
													</Radio.Group>
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="msme_reg_no"
													label="MSME Registration Number"
												>
													<CustomInput
														disabled={!values?.is_vendor_msme}
														name="msme_reg_no"
													/>
												</FormInput>
											</Col>
										</Row>
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput
													name="document_currency"
													label="Document Currency"
												>
													<CustomInput name="document_currency" />
												</FormInput>
											</Col>
											<Col lg={12}>
												<FormInput
													name="credit_period"
													label="Credit Period"
												>
													<CustomInput name="credit_period" />
												</FormInput>
											</Col>
										</Row>
										<Row gutter={16} justify="space-between">
											<Col lg={12}>
												<FormInput name="payment_tnc" label="Payment tnc">
													<CustomInput name="payment_tnc" />
												</FormInput>
											</Col>
										</Row>
									</Box>
								</Box>
							)}
							<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
								<CancelButton
									onClick={() => navigate('/vendor-list')}
									type="button"
								>
									Cancel
								</CancelButton>
								<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
									{isEditMode ? 'Update' : 'Submit'}
								</Button>
							</Box>
							<Debug />
						</Form>
					</Box>
				);
			}}
		</Formik>
	);
}

VendorAllSectionForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
	activeTab: PropTypes.any,
};
